import { useTranslation } from 'react-i18next';

import RedesignConfirmModal from './RedesignConfirmModal';

interface LogoutConfirmationModalProps {
	visible: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

function LogoutConfirmationModal({ visible, onClose, onConfirm }: LogoutConfirmationModalProps) {
	const { t } = useTranslation();

	if (!visible) return null;

	return (
		<RedesignConfirmModal
			title={t('T_SITE_MENU_LOGOUT')}
			message={t('T_SITE_MODAL_LOGOUT_CONFIRMATION', {
				defaultValue: 'Are you sure you want to log out?',
			})}
			cancelLabel={t('T_Cancel')}
			confirmLabel={t('T_SITE_MENU_LOGOUT')}
			onCancel={onClose}
			onConfirm={onConfirm}
			cancelTestId='cta-logout-cancel'
			confirmTestId='cta-logout-confirm'
		/>
	);
}

export default LogoutConfirmationModal;
